<template>
  <!-- Dialogo para indicar errores Angel -->
  <v-dialog v-model="dialogNuevaNomina.estatus" persistent max-width="1000">
    <v-card>
      <v-card-title primary-title> Solicitar requisición </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6" lg="4">
            <v-autocomplete
              filled
              dense
              clearable
              v-model="tipo_requisicion"
              :items="requisiciones"
              label="Tipo de requisición"
              persistent-hint
              item-text="tipo_requisicion"
              item-value="idtipo_requisiciones"
            >
            </v-autocomplete>

            <v-autocomplete
              filled
              dense
              clearable
              v-model="id_ciclo"
              :items="ciclos"
              label="Selecciona ciclo actual"
              persistent-hint
              item-text="ciclo"
              item-value="id_ciclo"
            >
            </v-autocomplete>

            <v-autocomplete
              v-if="showSecondAutocomplete"
		          filled
		          dense
		          clearable
		          v-model="id_proyecto"
		          :items="proyectos"
		          label="Selecciona un proyecto"
		          persistent-hint
		          item-text="proyecto"
		          item-value="id_proyecto"	          
		        >
		        </v-autocomplete>

            <v-textarea
              v-model="comentarios"
              filled
              dense
              label="Comentarios"
              rows="3"
            >
            </v-textarea>
          </v-col>

          <!-- Apartado para subir cotizaciones -->
          <!-- <v-col>
            <v-file-input
              v-model="files"
              accept="image/png, image/jpeg, image/bmp, application/pdf"
              placeholder="Selecciona tus imagenes"
              label="Subir Cotizaciones"
              multiple
              prepend-icon="mdi-paperclip"
              @change="cargarFotos()"
            >
              <template v-slot:selection="{ index, text }">
                <v-chip
                  small
                  label
                  color="primary"
                  close
                  @click:close="eliminarfile(index, text)"
                >
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
 
            <v-btn
              v-bind:disabled="!files.length"
              color="primary"
              tile
              small
              @click="subirCotizacion(), (verTabla = false)"
            >
              <v-icon small left>mdi-plus</v-icon>
              Subir Cotizaciones
            </v-btn>

            <v-row>
              <v-col cols="12" md="6" v-for="(img, i) in vistaPrevias" :key="i">
                <v-card
                  class="py-4 shadowCard"
                  v-if="img.extensioArchivo != 'pdf'"
                >
                  <v-img :src="img.url" contain aspect-ratio="2"></v-img>
                  <v-btn
                    color="error"
                    small
                    @click="eliminarFoto(img.url)"
                    top
                    right
                    absolute
                    fab
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-card>
                <v-card
                  class="py-4 shadowCard"
                  v-if="img.extensioArchivo == 'pdf'"
                >
                  <embed :src="img.url" type="application/pdf" />
                  <v-btn
                    color="error"
                    small
                    @click="eliminarFoto(img.url)"
                    top
                    right
                    absolute
                    fab
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-card>
              </v-col>
            </v-row>
          </v-col> -->
        </v-row>

        <v-btn
          v-bind:disabled="!tipo_requisicion || !id_ciclo || !comentarios"
          color="primary"
          @click="(dialog = true), (verTabla = false)"
          tile
          small
          class="mr-2"
        >
          <v-icon small left>mdi-plus</v-icon>
          Partida
        </v-btn>

        <v-btn
          v-bind:disabled="!tipo_requisicion || !id_ciclo || !comentarios"
          color="primary"
          @click="dialogPartidas.estatus = true"
          tile
          small
        >
          <v-icon small left>mdi-plus</v-icon>
          Multiples Partidas
        </v-btn>

        <br></br>
        <v-file-input
          v-model="files"
          accept="image/png, image/jpeg, image/bmp, application/pdf"
          placeholder="Selecciona tus imagenes"
          label="Subir Cotizaciones"
          multiple
          prepend-icon="mdi-paperclip"
          @change="cargarFotos()"
        >
          <template v-slot:selection="{ index, text }">
            <v-chip
              small
              label
              color="primary"
              close
              @click:close="eliminarfile(index, text)"
            >
              {{ text }}
            </v-chip>
          </template>
        </v-file-input>

        <v-btn
          v-bind:disabled="!files.length"
          color="primary"
          tile
          small
          @click="subirCotizacion(), (verTabla = false)"
        >
          <v-icon small left>mdi-plus</v-icon>
          Subir Cotizaciones
        </v-btn>

        <v-row>
          <v-col cols="12" md="6" v-for="(img, i) in vistaPrevias" :key="i">
            <v-card
              class="py-4 shadowCard"
              v-if="img.extensioArchivo != 'pdf'"
            >
              <v-img :src="img.url" contain aspect-ratio="2"></v-img>
              <v-btn
                color="error"
                small
                @click="eliminarFoto(img.url)"
                top
                right
                absolute
                fab
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-card>
            <v-card
              class="py-4 shadowCard"
              v-if="img.extensioArchivo == 'pdf'"
            >
              <embed :src="img.url" type="application/pdf" />
              <v-btn
                color="error"
                small
                @click="eliminarFoto(img.url)"
                top
                right
                absolute
                fab
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
        <br></br>
    
        <!-- <v-btn color="primary" @click="dialogSubirComprobante = true"><v-icon>mdi-plus</v-icon> Subir Cotización</v-btn> -->

        <v-data-table
          v-if="verTabla"
          :headers="headers"
          :items="detalles"
          dense
          class="elevation-0 mt-4"
        >
          <template v-slot:item.id_plantel="{ item }">
            <span>{{
              planteles.find((el) => el.id_plantel == item.id_plantel).plantel
            }}</span>
          </template>

          <template v-slot:item.id_elemento_requisicion="{ item }">
            <span>{{
              elementos.find(
                (el) =>
                  el.id_elemento_mantenimiento == item.id_elemento_requisicion
              ).elemento_mantenimiento
            }}</span>
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-actions>
        <v-btn
          dark
          block
          @click="dialogNuevaNomina.estatus = false"
          color="primary"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialog" max-width="350px">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="red" dark rounded small icon @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="black--text">
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                label="Elemento de requisición"
                filled
                dense
                clearable
                v-model="editedItem.id_elemento_requisicion"
                :items="elementos"
                persistent-hint
                item-text="elemento_mantenimiento"
                item-value="id_elemento_mantenimiento"
              >
              </v-autocomplete>

              <v-autocomplete
                filled
                dense
                clearable
                v-model="editedItem.id_plantel"
                :items="planteles"
                label="Selecciona plantel"
                persistent-hint
                item-text="plantel"
                item-value="id_plantel"
              >
              </v-autocomplete>

              <v-text-field
                filled
                label="Concepto"
                dense
                v-model="editedItem.concepto"
              ></v-text-field>

              <v-text-field
                filled
                label="Cantidad"
                dense
                type="number"
                v-model="editedItem.cantidad"
              ></v-text-field>

              <v-text-field
                filled
                label="Costo Unit."
                dense
                type="number"
                v-model="editedItem.costo_unitario"
              ></v-text-field>

              <v-text-field
                filled
                label="Costo total"
                dense
                readonly
                v-model="editedItem.costo_total"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn dark block @click="agregar()" color="primary">Agregar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <Loader v-if="cargar" :loader="loader" />

    <MultiplesPartidas
      v-if="dialogPartidas.estatus"
      :dialogPartidas="dialogPartidas"
      @cargarPartidaMultiple="cargarPartidaMultiple"
    />
  </v-dialog>
</template>


<script>
import { mapGetters } from "vuex";

// Componentes
import Alerta from "@/components/alertas/Alerta.vue";
import Loader from "@/components/alertas/Loader.vue";

import validarErrores from "@/mixins/validarErrores";
import MultiplesPartidas from "@/components/egresos/MultiplesPartidas.vue";

export default {
  props: ["dialogNuevaNomina"],

  mixins: [validarErrores],

  data: () => ({
    // Alertas
    parametros: {
      dialogError: false,
      mensaje: "",
      color: "",
    },

    respuestaAlerta: false,
    loader: true,
    cargar: false,

    dialog: false,
    dialogDelete: false,
    headers: [
      { text: "Elemento Compra", value: "id_elemento_requisicion" },
      { text: "Concepto", value: "concepto" },
      { text: "Plantel", value: "id_plantel" },
      { text: "Cantidad", value: "cantidad" },
      { text: "Costo Unit.", value: "costo_unitario" },
      { text: "Total", value: "costo_total" },
      { text: "Actions", value: "actions", sortable: false },
    ],

    ciclo: null,
    comentarios: "Pago servicio de las sucursales",

    opVisualizacion: 1,

    editedIndex: -1,

    editedItem: {
      id_elemento_requisicion: 0,
      id_plantel: 0,
      concepto: "Pago de",
      cantidad: 1,
      costo_unitario: 0,
      costo_total: 0,
      id_empleado: 0,
      detalles: [],
    },

    defaultItem: {
      id_elemento_requisicion: 0,
      id_plantel: 0,
      concepto: "Pago de",
      cantidad: 1,
      costo_unitario: 0,
      costo_total: 0,
      id_empleado: 0,
      detalles: [],
    },

    detalles: [],
    empleados: [],
    elementos: [],
    planteles: [],
    verTabla: true,
    fotos: [],
    files: [],
    vistaPrevias: [],
    dialogEliminar: false,
    id_proyecto:0,
    proyectos:[],

    id_usuario_solicita: "",
    id_sucursal_solicita: "",
    id_requisicion_compra_estatus: "",
    id_usuario_ultimo_cambio: "",

    id_usuario_compra: 28,
    id_ciclo: 0,
    comentarios: "",
    idrequisicion_compra: null,
    ciclos: [],
    opEscuela: 1,
    tipo_requisicion: 0,
    requisiciones: [],
    dialogPartidas: {
      estatus: false,
    },
  }),

  components: {
    Alerta,
    Loader,
    MultiplesPartidas
  },

  computed: {
    ...mapGetters("login", ["getUsuarioLMS"]),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },

    showSecondAutocomplete() {
      return this.id_ciclo === 136 || this.id_ciclo === 137 || this.id_ciclo === 202; // muestra el segundo autocomplete solo cuando id_ciclo es igual a "01"
      },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },

    "editedItem.cantidad"(value) {
      if (value && this.editedItem.costo_unitario) {
        this.editedItem.costo_total = value * this.editedItem.costo_unitario;
      }
    },

    "editedItem.costo_unitario"(value) {
      if (this.editedItem.cantidad && value) {
        this.editedItem.costo_total = value * this.editedItem.cantidad;
      }
    },

    "editedItem.id_elemento_requisicion"(value) {
      if (this.editedItem.id_elemento_requisicion) {
        this.editedItem.concepto =
          "Pago de: " +
          this.elementos.find(
            (el) =>
              el.id_elemento_mantenimiento ==
              this.editedItem.id_elemento_requisicion
          ).elemento_mantenimiento;
      }
    },
  },

  async created() {
    this.cargar = true;
    this.id_usuario_solicita = this.getUsuarioLMS.iderp;
    this.id_sucursal_solicita = this.getUsuarioLMS.id_plantel;
    this.id_usuario_ultimo_cambio = this.getUsuarioLMS.iderp

    await this.getCiclosActivos();
    await this.getPlanteles();
    await this.getElementosCompras();
    await this.getTipoRequisiciones();
    await this.getProyectos()

    this.cargar = false;
  },

  methods: {
    //Angel
    cargarFotos() {
      if (this.files.length < 1) {
        return;
      }

      this.files.forEach((element, index) => {
        // creamos una variable tipo FormData
        let formData = new FormData();
        //se crea el objeto y se le agrega como un apendice el archivo
        formData.append("file", element);
        //mandamos a ocvertir la imagen a base64 pero mandamos el docuemnto, el formdata, el nombre
        this.getBase64(element, formData);
      });
    },

    getBase64(file, formData) {
      var me = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        
        const nombreSplit = file.name.split(".");
        const extensioArchivo = nombreSplit[nombreSplit.length - 1];
        console.log(file)
        me.vistaPrevias.push({
          url: reader.result,
          formData: formData,
          image_name: file.name,
          file,
          extensioArchivo,
        });
      };
    },

    eliminarFoto(value) {
      this.vistaPrevias.forEach((element, index) => {
        if (element.url == value) {
          this.vistaPrevias.splice(index, 1);
        }
      });
    },

    eliminarfile(index, value) {
      this.files = this.files.filter((el) => {
        return el.name != value;
      });
    },

    getCiclosActivos() {
      this.ciclos = [];
      return this.$http
        .get("ciclos.activos.erp")
        .then((response) => {
          this.ciclos = response.body;
        })
        .catch((error) => {
          this.validarError(error);
        })
        .finally(() => {
          this.cargar = false;
        });
    },

    getProyectos () {
        this.proyectos = []
        return this.$http.get('consultar.proyectos').then(response=>{
        	this.proyectos = response.body
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
    },

    getPlanteles() {
      this.planteles = [];
      return this.$http
        .get("planteles.activos")
        .then((response) => {
          this.planteles = response.body;
        })
        .catch((error) => {
          this.validarError(error);
        })
        .finally(() => {
          this.cargar = false;
        });
    },

    getElementosCompras() {
      this.elementos = [];
      return this.$http
        .get("consultar.elemtos.compra")
        .then((response) => {
          this.elementos = response.body;
        })
        .catch((error) => {
          this.validarError(error);
        })
        .finally(() => {
          this.cargar = false;
        });
    },

    getTipoRequisiciones() {
      this.requisiciones = [];
      return this.$http
        .get("consultar.requisiciones")
        .then((response) => {
          this.requisiciones = response.body;
        })
        .catch((error) => {
          this.validarError(error);
        })
        .finally(() => {
          this.cargar = false;
        });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.verTabla = true;
    },

    guardar() {},

    async agregar() {
      // Guardamos el detalle

      let elemento = this.elementos.find(
        (el) =>
          el.id_elemento_mantenimiento ==
          this.editedItem.id_elemento_requisicion
      );
      let plantel = this.planteles.find(
        (el) => el.id_plantel == this.editedItem.id_plantel
      );

      // Validamos que el elemento se haya seleccionado correctamente
      if (!elemento) {
        return this.validarErrorDirecto("Favor de seleccionar un elemento");
      }
      // Validamos que el palntel se haya seleccionado correctamente
      if (!plantel) {
        return this.validarErrorDirecto("Favor de seleccionar un plantel");
      }
      // Validamos que la cantidad se haya seleccionado correctamente
      if (this.editedItem.cantidad == "") {
        return this.validarErrorDirecto("Favor agregar la cantidad");
      }
      // Validamos que el costo se haya seleccionado correctamente
      if (this.editedItem.costo_unitario == "") {
        return this.validarErrorDirecto("Favor de agregar el costo unitario");
      }

      // Desestructuramos el elemento
      const { elemento_mantenimiento, automatico, id_elemento_requisicion } =
        elemento;

      let detalles = [];
      detalles.push(this.editedItem);

      this.cargar = true;
      let fotos = [];
      if (this.vistaPrevias.length) {
        let respuesta = await this.subirFotosServidor();
        fotos = respuesta.body;
      }

      var payload = {
        registro: this.idrequisicion_compra,
        id_usuario_solicita: this.id_usuario_solicita,
        id_sucursal_solicita: this.id_sucursal_solicita,
        id_requisicion_compra_estatus: 1,
        id_usuario_ultimo_cambio: this.id_usuario_ultimo_cambio,
        id_usuario_compra: 28,
        tipo_requisicion: this.tipo_requisicion,
        id_ciclo: this.id_ciclo,
        id_proyecto: this.id_proyecto,
        comentarios: this.comentarios,
        detalles,
        fotos: [],
      };

      if (
        this.detalles.some(
          (detalle) =>
            JSON.stringify(detalle) === JSON.stringify(this.editedItem)
        )
      ) {
        this.validarError(
          "Esta partida ya ha sido agregada anteriormente en esta requisición"
        );
        return;
      }

      return this.$http
        .post("generar.nomina.operaciones", payload)
        .then((response) => {
          this.validarSuccess(response.body.message);
          this.detalles.push(this.editedItem);
          this.idrequisicion_compra = response.body.idrequisicion_compra;
          this.cargar = false;
          // Agregamos primero los datos
          this.dialog = false;
          this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
          });
          this.verTabla = true;
        })
        .catch((error) => {
          this.validarError(error);
        })
        .finally(() => {
          this.cargar = false;
        });
    },

     async subirCotizacion(){
      	// Guardamos el detalle

         if( !this.idrequisicion_compra){return this.validarErrorDirecto('Favor de crear primero la requisición')}

		      this.cargar = true
          let fotos = []
          if(this.vistaPrevias.length){
            let respuesta = await this.subirFotosServidor( )
            fotos = respuesta.body
          }

  	      var payload = {
        		registro:                      this.idrequisicion_compra,
        		id_usuario_solicita:           this.id_usuario_solicita,
  		      id_sucursal_solicita:          this.id_sucursal_solicita,
  		      id_usuario_ultimo_cambio:      this.id_usuario_ultimo_cambio,
  		      id_usuario_compra:             28,
  		      tipo_requisicion:              this.tipo_requisicion,
  		      id_ciclo:                      this.id_ciclo,
  		      comentarios:                   this.comentarios,
  		      detalles:[],
  			    fotos
  	      }
        
          return this.$http.post('generar.nomina.operaciones', payload ).then(response=>{
            this.validarSuccess( response.body.message )
          	this.cargar      = false
  	      	// Agregamos primero los datos
  	      	this.dialog = false
  	      	this.$nextTick(() => {
  	          this.editedItem = Object.assign({}, this.defaultItem)
  	          this.editedIndex = -1
  	        })
  	        this.verTabla = true
          }).catch( error =>{
            this.validarError( error )
          })
            .finally(() => {
            this.cargar = false;
        });
        },

	    subirFotosServidor( ){
        let formData = new FormData();

        for( const i in this.vistaPrevias ){
          formData.append('file', this.vistaPrevias[i].file )
        }

        return new Promise((resolve,reject)=>{
          // obtener la extensión del archivo
          // Hacemos la petición
          this.$http.post(`egresos.subir.fotos`, formData ).then(response=>{
            resolve( response )
          }).catch( error =>{
            this.validarError( error )
          }).finally( () => { this.cargar = false })
        })
      },

    cargarPartidaMultiple(value) {
      for (const i in value) {
        this.detalles.push(value[i]);
      }

      this.dialogPartidas.estatus = false;

      var payload = {
        registro: this.idrequisicion_compra,
        id_usuario_solicita: this.id_usuario_solicita,
        id_sucursal_solicita: this.id_sucursal_solicita,
        id_requisicion_compra_estatus: 1,
        id_usuario_ultimo_cambio: this.id_usuario_ultimo_cambio,
        id_usuario_compra: 28,
        tipo_requisicion: this.tipo_requisicion,
        id_ciclo: this.id_ciclo,
        comentarios: this.comentarios,
        detalles: value,
        fotos: [],
      };

      return this.$http
        .post("generar.nomina.operaciones", payload)
        .then((response) => {
          this.validarSuccess(response.body.message);
          this.idrequisicion_compra = response.body.idrequisicion_compra;
          this.cargar = false;
          // Agregamos primero los datos
          this.verTabla = true;
        })
        .catch((error) => {
          this.validarError(error);
        })
        .finally(() => {
          this.cargar = false;
        });
    },
  },
};
</script>
